export default {
  //设置cookie
  set: function (name, value, opts) {
    opts = opts || {}
    let expires = opts.expires
    let domain = opts.domain
    let path = opts.path || '/'
    let secure = opts.secure ? 'secure' : ''

    let cookie = name + '=' + encodeURI(value) + ';'
    if (expires || expires === 0) {
      let s = new Date(expires)
      cookie += 'expires=' + s.toUTCString() + ';'
      /*var oDate = new Date();
      var expiresTime = oDate.getTime() + expires
      // oDate.setDate( oDate.getTime() + expires );
      cookie += ' expires=' + expiresTime + ';';
      // cookie += ' expires=' + oDate.toUTCString() + ';';*/
    }

    if (domain) cookie += ' domain=' + domain + ';'
    if (path) cookie += ' path=' + path + ';'
    if (secure) cookie += ' secure;'
    return document.cookie = cookie
  },
  //获取cookie
  get: function (name) {
    let reg = new RegExp('(^|; )' + name + '=([^;]*)(;|$)');
    let result = document.cookie.match(reg);
    if (result) {
      return decodeURI(result[2]);
    } else {
      return '';
    }
  },
  //移除cookie
  remove: function (name) {
    this.set(name, '', { expires: -1 });
  }
};



//////////////////
// WEBPACK FOOTER
// ./static/js/cookie.js
// module id = g5nd
// module chunks = 16